<div class="form form--custom-family-member form--full-width">
  <div class="form__field">
    <custom-name-long [noIndent]="true"></custom-name-long>
  </div>
  <div class="form__inline-field-container form__inline-field-container--two-fields">
    <div class="form__field">
      <select-basic
        [valueOptions]="relationshipToInsuredOptions"
        [label]="relationshipDisplayText()"
        [noIndent]="true"
        [property]="getFullPropString(getCustomProp(3))"
      ></select-basic>
    </div>
    <div class="form__field">
      <basic-text-input
        [placeholder]="'Date of Birth'"
        [propertyName]="questionItem.prop + '.dob'"
        [parserType]="'Date'"
        [formatterType]="'date_mmddyyyy'"
        [isDriversLicense]="false"
        [inputMask]="mask"
      ></basic-text-input>
    </div>
  </div>
  <div class="form__label">
    <basic-label [noIndent]="true" [overrideDisplayText]="'Amount of insurance coverage in-force'"></basic-label>
  </div>
  <div class="form__inline-field-container form__inline-field-container--two-fields">
    <div class="form__field">
      <basic-text-input
        [placeholder]="'Group Insurance'"
        [parserType]="'Currency'"
        [formatterType]="'currency'"
        [propertyName]="questionItem.prop + '.existingPolicies.groupCoverageInForce'"
      ></basic-text-input>
    </div>
    <div class="form__field">
      <basic-text-input
        [placeholder]="'Individual Insurance'"
        [parserType]="'Currency'"
        [formatterType]="'currency'"
        [propertyName]="questionItem.prop + '.existingPolicies.nonGroupCoverageInForce'"
      ></basic-text-input>
    </div>
  </div>
  <div class="form__label">
    <basic-label [noIndent]="true" [overrideDisplayText]="'Amount of insurance coverage applied for'"></basic-label>
  </div>
  <div class="form__inline-field-container form__inline-field-container--two-fields">
    <div class="form__field">
      <basic-text-input
        [placeholder]="'Group Insurance'"
        [parserType]="'Currency'"
        [formatterType]="'currency'"
        [propertyName]="questionItem.prop + '.existingPolicies.groupCoverageAppliedFor'"
      ></basic-text-input>
    </div>
    <div class="form__field">
      <basic-text-input
        [placeholder]="'Individual Insurance'"
        [parserType]="'Currency'"
        [formatterType]="'currency'"
        [propertyName]="questionItem.prop + '.existingPolicies.nonGroupCoverageAppliedFor'"
      ></basic-text-input>
    </div>
  </div>
</div>
